import { render } from "./MonthlyInvestment.vue?vue&type=template&id=1afaf044&scoped=true"
import script from "./MonthlyInvestment.vue?vue&type=script&lang=js"
export * from "./MonthlyInvestment.vue?vue&type=script&lang=js"

import "./MonthlyInvestment.vue?vue&type=style&index=0&id=1afaf044&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afaf044"]])

export default __exports__